export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
export const API_VERSION = process.env.REACT_APP_API_VERSION || "v1";

// Site identity — single source of truth for all URL/SEO references
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://appointigo.com';
export const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'Appointigo';
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard.appointigo.com';

export const ENABLE_PHONE_OTP = process.env.REACT_APP_ENABLE_PHONE_OTP ? process.env.REACT_APP_ENABLE_PHONE_OTP === 'true' : true;